<h2 mat-dialog-title>Logo da empresa</h2>

<mat-dialog-content class="logo-dialog-content">
    <div class="preview-area" [class.empty]="!urlExibida">
        @if (urlExibida) {
            <img [src]="urlExibida" alt="Logo da empresa" />
        } @else {
            <div class="placeholder">
                <mat-icon>add_photo_alternate</mat-icon>
                <span>Sem logo</span>
            </div>
        }
    </div>

    <div class="hint">
        Formatos aceitos: WebP, JPG, JPEG, PNG, SVG. Tamanho máximo: 2 MB.
    </div>

    <input type="file" #fileInput accept=".webp,.jpg,.jpeg,.png,.svg" (change)="onArquivoSelecionado($event)" hidden />

    <div class="dialog-actions-row">
        <button type="button" mat-button class="logo-action-button" (click)="fileInput.click()">
            <mat-icon>upload</mat-icon>
            {{ urlExibida ? 'Trocar imagem' : 'Selecionar imagem' }}
        </button>

        @if (data?.urlLogoAtual && !marcadoParaRemover) {
            <button type="button" mat-button class="logo-action-button" (click)="marcarParaRemover()">
                <mat-icon>delete</mat-icon>
                Remover logo
            </button>
        }

        @if (marcadoParaRemover) {
            <button type="button" mat-button class="logo-action-button" (click)="desfazerRemocao()">
                <mat-icon>undo</mat-icon>
                Desfazer remoção
            </button>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
    <button type="button" mat-flat-button class="btn-primary" (click)="confirmar()"
        [disabled]="!arquivoSelecionado && !marcadoParaRemover">
        Confirmar
    </button>
</mat-dialog-actions>
